import FikkaThumnail from "../../../src/Assets/Images/PortfolioImages/FikkaThumnail.webp";
import MissonToCureThumbnail from "../../../src/Assets/Images/PortfolioImages/MissionToCureThumbnails.webp";
import JagsThumbnail from "../../../src/Assets/Images/PortfolioImages/JagsThumbnails.webp";
import Idesign from "../../../src/Assets/Images/PortfolioImages/IDesignBanner.png";
import SFsbannertab from "../../../src/Assets/Images/PortfolioImages/SfsTabimage.webp";
import MobileIdlab from "../../../src/Assets/Images/PortfolioImages/MID.webp";
import Aagam from "../../../src/Assets/Images/PortfolioImages/Aagambanner.webp";
import AngleAlign from "../../../src/Assets/Images/PortfolioImages/AngleAlignbanner.webp";
import GlidinTab from "../../../src/Assets/Images/PortfolioImages/GlidinTabImage.webp";
import Gptw from "../../../src/Assets/Images/PortfolioImages/selected.webp";
import Amyraa from "../../../src/Assets/Images/PortfolioImages/1.webp";
import lifesupperters from "../../../src/Assets/Images/PortfolioImages/6.webp";
import pesticies from "../../../src/Assets/Images/PortfolioImages/9.webp";
import theotransfara from "../../../src/Assets/Images/PortfolioImages/11.webp";
import Genwe from "../../../src/Assets/Images/PortfolioImages/12.webp";
import creativewebo from "../../../src/Assets/Images/PortfolioImages/13.webp";
import LockAndKey from "../../../src/Assets/Images/PortfolioImages/16.webp";
import GrandMaster from "../../../src/Assets/Images/PortfolioImages/17.webp";
import Plus91 from "../../../src/Assets/Images/PortfolioImages/18.webp";
import Financepandit from "../../../src/Assets/Images/PortfolioImages/19.webp";
import mansamata from "../../../src/Assets/Images/PortfolioImages/20.webp";
import greengati from "../../../src/Assets/Images/PortfolioImages/21.webp";
import bagaria from "../../../src/Assets/Images/PortfolioImages/22.webp";
import mish from "../../../src/Assets/Images/PortfolioImages/23.webp";
import credence from "../../../src/Assets/Images/PortfolioImages/24.webp";
import creativegarage from "../../../src/Assets/Images/PortfolioImages/25.webp";
import Allthatthereis from "../../../src/Assets/Images/PortfolioImages/29.webp";
import greenglobe from "../../../src/Assets/Images/PortfolioImages/30.webp";
import weqsol from "../../../src/Assets/Images/PortfolioImages/31.webp";
import sanisa from "../../../src/Assets/Images/PortfolioImages/32.webp";
import praxia from "../../../src/Assets/Images/PortfolioImages/33.webp";
import Airigo from "../../Assets/Images/PortfolioImages/Airigo.webp";
import AsianPaints from "../../Assets/Images/PortfolioImages/AsianPaints.webp";
import Sam from "../../Assets/Images/PortfolioImages/Sam.webp";
import ChallengePlus from "../../Assets/Images/PortfolioImages/ChallengePlusImage.webp";
import Rincell from "../../Assets/Images/PortfolioImages/rincell.webp";
import JccSports from "../../Assets/Images/PortfolioImages/jccsports.webp";
import Shills from "../../Assets/Images/PortfolioImages/shills.webp";
import karnawat from "../../Assets/Images/PortfolioImages/karnawat.webp";
import fourhealingwalls from "../../Assets/Images/PortfolioImages/fourhealingwalls.webp";
import pulsar from "../../Assets/Images/PortfolioImages/pulsar_p.webp";
import greenstar from "../../Assets/Images/PortfolioImages/greenstar_p.webp";
import edulauncher from "../../Assets/Images/PortfolioImages/edulauncher_p.webp";
import prac from "../../Assets/Images/PortfolioImages/prac_p.webp";
import asaco from "../../Assets/Images/PortfolioImages/asaco_p.webp";
import cyringe from "../../Assets/Images/PortfolioImages/cyringe.webp";
import tiqet from "../../Assets/Images/PortfolioImages/tiqet.webp";
import zeone from "../../Assets/Images/PortfolioImages/zeone.webp";
import goldstandard from "../../Assets/Images/PortfolioImages/goldstandard.webp";
import jphome from "../../Assets/Images/PortfolioImages/jphome.webp";
import veekay from "../../Assets/Images/PortfolioImages/veekay.webp";
import prost from "../../Assets/Images/PortfolioImages/prost.webp";
import altnix from "../../Assets/Images/PortfolioImages/altnix.webp";

export const portfolioitems = [
  {
    title: "Asian Paints",
    image: AsianPaints,
    link: "https://www.asianpaints.com/",
    external: true,
    category: ["Web Application", "Mobile Application"],
    subCategory: "Portfolio",
  },
  {
    title: "Bajaj Pulsar",
    image: pulsar,
    link: "https://flourishing-praline-b36b43.netlify.app/",
    external: true,
    category: "Mobile Application",
  },
  {
    title: "Fikaa",
    image: FikkaThumnail,
    link: "/fikaacasestudy",
    external: false,
    category: "Mobile Application",
  },
  {
    title: "Cyringe (AI)",
    image: cyringe,
    link: "https://cyringe.ai/",
    external: true,
    category: "AI / IoT / Analytics",
    subCategory: "AI",
  },
  {
    title: "Tiqet (Analytics)",
    image: tiqet,
    link: "https://tiquet-dev.web.app/",
    external: true,
    category: "AI / IoT / Analytics",
    subCategory: "Analytics",
  },
  {
    title: "Zeone (IoT)",
    image: zeone,
    link: "https://zeone.in/",
    external: true,
    category: "AI / IoT / Analytics",
    subCategory: "IoT",
  },
  {
    title: "Gold Standard Sports",
    image: goldstandard,
    link: "https://goldstandardsports.in/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Jphome",
    image: jphome,
    link: "https://www.jphomemasala.com/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Veekay",
    image: veekay,
    link: "https://veekaydiamants.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Prost",
    image: prost,
    link: "https://prost.co.in/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Altnix",
    image: altnix,
    link: "https://altnix.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Amyraa",
    image: Amyraa,
    link: "https://amyraa.app/",
    external: true,
    category: ["Web Application", "Mobile Application"],
    subCategory: "Ecommerce",
  },
  {
    title: "JCC Sports",
    image: JccSports,
    link: "https://jccsprts.com/",
    external: true,
    category: "Mobile Application",
  },
  {
    title: "Surgeons For Surgeons",
    image: SFsbannertab,
    link: "/sfscasestudies",
    external: false,
    category: "Mobile Application"
  },
  {
    title: "GenWe",
    image: Genwe,
    link: "https://genwe.today/",
    external: true,
    category: ["Web Application", "Mobile Application"],
    subCategory: "Portfolio",
  },
  {
    title: "Great Place To Work",
    image: Gptw,
    link: "https://www.greatplacetowork.in/for-all-community",
    external: true,
    category: "Mobile Application"
  },
  {
    title: "Lifesupporters",
    image: lifesupperters,
    link: "http://www.lifesupporters.in/",
    external: true,
    category: ["Web Application", "Mobile Application"],
    subCategory: "Portfolio",
  },
  {
    title: "India pesticides limited",
    image: pesticies,
    link: "https://www.indiapesticideslimited.com/",
    external: true,
    category: ["Web Application", "Mobile Application"],
    subCategory: "Portfolio",
  },
  {
    title: "Mission To Cure",
    image: MissonToCureThumbnail,
    link: "/missiontocurecasestudy",
    external: false,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Jags",
    image: JagsThumbnail,
    link: "https://www.jagsindia.com/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Idesign",
    image: Idesign,
    link: "/iDesignCasestudy",
    external: false,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Mobile Id Labs",
    image: MobileIdlab,
    link: "/mobileidlabscasestudy",
    external: false,
    category: "Mobile Application",
  },
  {
    title: "Glidin",
    image: GlidinTab,
    link: "/glidincasestudies",
    external: false,
    category: ["Web Application", "Mobile Application"],
    subCategory: "Portfolio",
  },
  {
    title: "Aagam",
    image: Aagam,
    link: "https://aagam.org.in/home.html",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Theo Transfra",
    image: theotransfara,
    link: "https://theotransfra.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Creative webo",
    image: creativewebo,
    link: "https://creativewebo.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Angle and Align",
    image: AngleAlign,
    link: "https://angleandalign.in/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Lock and key",
    image: LockAndKey,
    link: "https://lockandkeyproperties.in/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Grand Master's",
    image: GrandMaster,
    link: "https://www.grandmasters.co/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Plus 91",
    image: Plus91,
    link: "https://plus91.co/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Finance Pandit",
    image: Financepandit,
    link: "https://www.finpandit.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Mansa Mata Finance",
    image: mansamata,
    link: "https://www.mansamatafinance.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Green Gati",
    image: greengati,
    link: "https://greengati.in/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Bagaria & Company",
    image: bagaria,
    link: "https://bagariaco.in/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Mish",
    image: mish,
    link: "https://mishindia.com/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Credence Consultants",
    image: credence,
    link: "https://www.credenceconsultants.in/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Creative Garage",
    image: creativegarage,
    link: "https://creative-garage.in/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Sa Ni Sa",
    image: sanisa,
    link: "https://sanisa.org/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Weqsol",
    image: weqsol,
    link: "https://weqsol.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Praxia",
    image: praxia,
    link: "https://www.praxia.co.in/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "All That There Is",
    image: Allthatthereis,
    link: "https://allthathereis.com/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Greenglobe Fuel Solutions",
    image: greenglobe,
    link: "https://www.greenglobe.world/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Aadinath Exports",
    image: Sam,
    link: "https://aadinathexports.com/",
    external: true,
    category: "Mobile Application"
  },
  {
    title: "Airigo",
    image: Airigo,
    link: "https://airigo.in/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Challenge Plus",
    image: ChallengePlus,
    link: "https://challengeplus.in/",
    external: true,
    category: ["Web Application", "Mobile Application"],
    subCategory: "Ecommerce",
  },
  {
    title: "Rincell",
    image: Rincell,
    link: "https://rincell.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Shills",
    image: Shills,
    link: "https://shillsprofessional.com/",
    external: true,
    category: ["Web Application", "Mobile Application"],
    subCategory: "Ecommerce",
  },
  {
    title: "Karnawat",
    image: karnawat,
    link: "https://karnawatinternational.com/",
    external: true,
    category: ["Web Application", "Graphic Design"],
    subCategory: "Portfolio",
  },
  {
    title: "Four Healing Walls",
    image: fourhealingwalls,
    link: "https://fourhealingwalls.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Greenstar Jewels",
    image: greenstar,
    link: "https://greenstarjewels.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Edulauncher",
    image: edulauncher,
    link: "https://edulauncher.com/",
    external: true,
    category: "Web Application",
    subCategory: "Portfolio",
  },
  {
    title: "Prac Jewels",
    image: prac,
    link: "https://pracjewels.com/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  },
  {
    title: "Asaco Fashion",
    image: asaco,
    link: "https://asacofashion.com/",
    external: true,
    category: "Web Application",
    subCategory: "Ecommerce",
  }
];
